import "./Dashboard.css";
import Topbar from "./Topbar";
import { Outlet } from "react-router-dom";

function Dashboard() {
  return (
    <div className="dashboard">
      <main className="dashboard-content">
        <div className="dashboard-content-inner">
          <Topbar />
          <Outlet />
        </div>
      </main>
    </div>
  );
}

export default Dashboard;